export default __webpack_public_path__ + "static/rocket-fe0cc244eb86f7e5ab29dc3974e80c91.svg";